
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4zpiX = parcelRequire("4zpiX");

var $4HWKL = parcelRequire("4HWKL");
(0, $4zpiX.Parse).initialize("AWkPplHMIY9BT8RKZR7cYj6KPMLuMeJ1GMGGOjDk", "bd328hdyqbuyg2976te31eghdt7679F6F6DF7GgFG9Ff");
(0, $4zpiX.Parse).serverURL = "https://api.snypinc.com/parse";
class $151801ff2268d0ac$var$Barber extends (0, $4zpiX.Parse).User {
    constructor(attributes){
        super(attributes);
    }
    getEmail() {
        return this.get("email");
    }
}
(0, $4zpiX.Parse).Object.registerSubclass("_User", $151801ff2268d0ac$var$Barber);
function $151801ff2268d0ac$var$registerBarber() {
    (0, $4zpiX.Parse).User.logOut();
    const email = document.getElementById("email-field").value;
    const fname = document.getElementById("fname-field").value;
    const lname = document.getElementById("lname-field").value;
    const license = document.getElementById("license-field").value;
    const dob = document.getElementById("dob-field").value;
    const photoid = document.getElementById("photoid").files[0];
    const photoidFile = new (0, $4zpiX.Parse).File("photoid", photoid);
    const customUser = new $151801ff2268d0ac$var$Barber({
        fname: fname,
        lname: lname,
        license: license,
        dob: dob,
        active: false,
        status: "new"
    });
    customUser.setUsername(email);
    customUser.setPassword($151801ff2268d0ac$var$generatePassword());
    customUser.setEmail(email);
    customUser.signUp().then((user)=>{
        user.set("photoid", photoidFile);
        user.save();
        (0, (/*@__PURE__*/$parcel$interopDefault($4HWKL))).modal(document.getElementById("register-docs")).hide();
        (0, (/*@__PURE__*/$parcel$interopDefault($4HWKL))).notification("Your registration has been submitted! We will contact you with further instructions.", {
            status: "success"
        });
        (0, $4zpiX.Parse).Cloud.run("sendWelcomeEmail", {
            data: {
                email: email,
                name: `${fname} ${lname}`
            }
        });
    }).catch((error)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($4HWKL))).notification(error.message, {
            status: "danger"
        });
    });
}
function $151801ff2268d0ac$var$generatePassword(length = 32) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789[]:;<>?/!@#$%^&*()|.,~";
    const charactersLength = characters.length;
    let counter = 0;
    while(counter < length){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}
const $151801ff2268d0ac$var$slider = document.getElementById("snypRange");
const $151801ff2268d0ac$var$count = document.getElementById("snypCount");
const $151801ff2268d0ac$var$earn = document.getElementById("snypEarn");
if ($151801ff2268d0ac$var$slider) $151801ff2268d0ac$var$slider.addEventListener("input", function() {
    $151801ff2268d0ac$var$count.innerHTML = this.value;
    $151801ff2268d0ac$var$earn.innerHTML = this.value * 75;
});
const $151801ff2268d0ac$var$emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $151801ff2268d0ac$var$email = document.getElementById("email-field");
const $151801ff2268d0ac$var$btn1 = document.getElementById("step1-next");
function $151801ff2268d0ac$var$enableNext1() {
    if ($151801ff2268d0ac$var$emailRegex.test($151801ff2268d0ac$var$email.value) === true) $151801ff2268d0ac$var$btn1.classList.replace("uk-disabled", "uk-button-primary");
    else $151801ff2268d0ac$var$btn1.classList.replace("uk-button-primary", "uk-disabled");
}
$151801ff2268d0ac$var$email.addEventListener("change", ()=>{
    $151801ff2268d0ac$var$enableNext1();
});
const $151801ff2268d0ac$var$fname = document.getElementById("fname-field");
const $151801ff2268d0ac$var$lname = document.getElementById("lname-field");
const $151801ff2268d0ac$var$state = document.getElementById("state-field");
const $151801ff2268d0ac$var$btn2 = document.getElementById("step2-next");
function $151801ff2268d0ac$var$enableNext2() {
    if ($151801ff2268d0ac$var$fname.value && $151801ff2268d0ac$var$lname.value) $151801ff2268d0ac$var$btn2.classList.replace("uk-disabled", "uk-button-primary");
    else $151801ff2268d0ac$var$btn2.classList.replace("uk-button-primary", "uk-disabled");
}
$151801ff2268d0ac$var$fname.addEventListener("change", ()=>{
    $151801ff2268d0ac$var$enableNext2();
});
$151801ff2268d0ac$var$lname.addEventListener("change", ()=>{
    $151801ff2268d0ac$var$enableNext2();
});
$151801ff2268d0ac$var$state.addEventListener("change", ()=>{
    $151801ff2268d0ac$var$enableNext2();
});
const $151801ff2268d0ac$var$form = document.getElementById("barber-register");
const $151801ff2268d0ac$var$photoid = document.getElementById("photoid");
const $151801ff2268d0ac$var$license = document.getElementById("license-field");
const $151801ff2268d0ac$var$dob = document.getElementById("dob-field");
const $151801ff2268d0ac$var$btn = document.getElementById("submit-registration");
function $151801ff2268d0ac$var$enableSubmit() {
    if ($151801ff2268d0ac$var$photoid.files?.length > 0 && $151801ff2268d0ac$var$license.value && $151801ff2268d0ac$var$dob.value) $151801ff2268d0ac$var$btn.removeAttribute("disabled");
    else $151801ff2268d0ac$var$btn.setAttribute("disabled", "true");
}
$151801ff2268d0ac$var$photoid.addEventListener("change", ()=>{
    $151801ff2268d0ac$var$enableSubmit();
});
$151801ff2268d0ac$var$license.addEventListener("change", ()=>{
    $151801ff2268d0ac$var$enableSubmit();
});
$151801ff2268d0ac$var$dob.addEventListener("change", ()=>{
    $151801ff2268d0ac$var$enableSubmit();
});
$151801ff2268d0ac$var$btn.addEventListener("click", ()=>{
    $151801ff2268d0ac$var$registerBarber();
});
$151801ff2268d0ac$var$form.addEventListener("submit", ()=>{
    $151801ff2268d0ac$var$registerBarber();
});


//# sourceMappingURL=barbers.7b190c8b.js.map
